import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/profile-card/profile-card.styles.ts
var profile_card_styles_default = r` ${component_styles_default} .profile-card { color: var(--sl-color-neutral-0); } .profile-card--has-avatar { padding-top: 0.625rem; } slot[name='avatar']::slotted(fadv-avatar), slot[name='avatar'] fadv-avatar { position: absolute; top: -1.5rem; left: 50%; transform: translateX(-50%); } .profile-card--has-badge .profile-card__items { justify-content: space-between; } .profile-card__items { display: flex; justify-content: flex-end; } `;

export {
  profile_card_styles_default
};
